import {
    ToggleButtonGroup,
    alpha,
    styled,
    toggleButtonGroupClasses,
} from '@mui/material';

// TODO: The buttins change size when clicked. Fix this.
const ButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
    backgroundColor: alpha(
        theme.palette.primary.main,
        theme.palette.action.selectedOpacity,
    ),
    [`& .${toggleButtonGroupClasses.grouped}`]: {
        margin: theme.spacing(0.5, 0.25),
        padding: 4,
        border: 0,
        borderRadius: theme.shape.borderRadius,
        textTransform: 'none',
        [`&.${toggleButtonGroupClasses.disabled}`]: {
            border: 0,
        },
    },
}));

export default ButtonGroup;
